<template>
  <video
    :width="width"
    :muted="mgnlProps.muted"
    :autoplay="mgnlProps.enableAutoplay"
    controls
    :controlsList="controlsList"
    :disablePictureInPicture="mgnlProps.disablePicInPic"
    :playsinline="mgnlProps.inlineOnly"
    :poster="thumbnail"
    :data-ab-id="mgnlProps?.dataABId"
  >
    <source
      :src="videoSrc"
      type="video/mp4"
    >
  </video>
</template>

<script lang="ts" setup>
import magnoliaGetters from '~/composables/getters/magnoliaGetters';
import { MediaBuilder, WrapperProps } from '~/components/Shared/MagnoliaElements/Media/Media.model';

const props = defineProps(WrapperProps);
const mgnlProps = MediaBuilder.build(props);
const { $domain } = useNuxtApp();

const width = mgnlProps.width ? `${mgnlProps.width}px` : 'auto';
const videoSrc = computed(() => (`${magnoliaGetters.getDefaultSrcAsset(mgnlProps.media, $domain.cmsAssetDomainPath)}#t=${mgnlProps.playback}`));
const controlsList = computed(() => (magnoliaGetters.getControlsList(mgnlProps)));
const thumbnail = computed(() => (mgnlProps.thumbnail?.[0]?.image?.link ? magnoliaGetters.getDefaultSrcAsset(mgnlProps.thumbnail[0].image, $domain.cmsAssetDomainPath) : ''));
</script>
